import { shuffleArray } from "../utills/common";
import { STUDY, STUDY_STEPS } from "../actions/types";
import { TEST_TYPE_TT, TEST_TYPE_CS, CARD_TYPE_OPEN, UNCLEAR_CATEGORY } from "../actions/constants";

const defaultTestData = {
  taskIndex: 0,
  taskAnswer: {},
  isTaskStarted: false,
  cardSort: {
    cards: [],
    feedback: "",
    categories: [],
    showInstruction: true,
    showConfirmation: false,
    userResponse: { cards: {}, categories: {} },
  },
};

const initialState = {
  test: null,
  error: null,
  branding: {},
  loading: false,
  overQuotaUrl: "",
  questionIndex: 0,
  participant: null,
  isPreview: false,
  isSavingTask: false,
  isTestRunning: false,
  isTestCompleted: false,
  testSurveyAnswers: {},
  testData: defaultTestData,
  isSavingParticipant: false,
  showPreviewHeader: true, // Show Preview Header
  activeStep: STUDY_STEPS.WELCOME, // Default Active Step
  testStartedAt: null, // Timestamp at which this test is started
  isTestTakenOnThisDevice: false, // Check if test is already taken on this device
};

const studyReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case STUDY.LOAD:
      return { ...state, ...payload };
    case STUDY.TASK_SAVING:
      return { ...state, isSavingTask: payload };
    case STUDY.COMPLETE:
      return initialState;

    case STUDY.UPDATE:
      const activeStep = payload?.activeStep || state?.activeStep;

      // Start Task
      if (payload?.initTask) {
        const { test, testData } = state;

        if (test?.type === TEST_TYPE_CS) {
          let { cards, categories } = test.card_sort;
          const { card, category } = test.settings.card_sort;

          // Open sort: testers build their own categories — drop the creator's ones but
          // KEEP the unclear category so its drop placeholder can render.
          if (test.settings.card_sort.type === CARD_TYPE_OPEN) categories = categories.filter((c) => c.type === UNCLEAR_CATEGORY);
          else if (category.shuffle) categories = shuffleArray(categories);
          if (card.shuffle) cards = shuffleArray(cards);

          if (category.unclear) {
            const unclearCategory = categories.find((cat) => cat.type === UNCLEAR_CATEGORY);
            const newCategories = categories.filter((cat) => cat.type !== UNCLEAR_CATEGORY);
            if (unclearCategory) categories = [unclearCategory, ...newCategories].map((cat) => ({ ...cat, catCards: [] }));
          } else {
            // Unclear setting disabled — make sure a leftover unclear category never reaches the board
            categories = categories.filter((cat) => cat.type !== UNCLEAR_CATEGORY);
          }

          const newTestData = { ...testData, cardSort: { ...testData.cardSort, showInstruction: true, cards, categories } };

          return { ...state, test, testData: newTestData, activeStep };
        } else {
          const taskIndex = payload.taskIndex ? payload.taskIndex : state.testData.taskIndex;

          // Seed the answer path with the home node ONLY when there is a single
          // home node. With multiple home nodes the starting root is unknown until
          // the participant navigates, so it's reconstructed on first interaction.
          const treeData = test?.tree?.treeData || [];
          const seedAnswer =
            test.type === TEST_TYPE_TT && treeData.length === 1 ? [{ id: treeData[0].id, label: treeData[0].name }] : [];

          const taskAnswer = {
            id: test.tasks[taskIndex]._id,
            startTime: new Date().getTime(),
            answer: seedAnswer,
          };

          return { ...state, activeStep, testData: { ...state?.testData, taskIndex, taskAnswer, isTaskStarted: false } };
        }
      }

      return { ...state, ...payload };

    case STUDY.SURVEY_LOAD:
      return {
        ...state,
        questionIndex: 0,
        testSurveyAnswers: { ...state.testSurveyAnswers, [payload]: state.testSurveyAnswers[payload] || [] },
      };
    case STUDY.SURVEY_SAVE:
      return { ...state, testSurveyAnswers: payload };
    case STUDY.MOVE_PREV:
      return { ...state, questionIndex: state.questionIndex - 1, isSavingTask: false };
    case STUDY.MOVE_NEXT:
      return { ...state, questionIndex: state.questionIndex + 1, isSavingTask: false };
    case STUDY.ATTEMPTED:
      const { test } = state;
      let comet = JSON.parse(localStorage.getItem("comet")) || [];
      if (comet?.length === 0 || (comet?.length && comet?.indexOf(test._id) === -1)) {
        localStorage.setItem("comet", JSON.stringify([...comet, test._id]));
      }

      return { ...state };

    default:
      return state;
  }
};

export default studyReducer;
